<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:svgjs="http://svgjs.com/svgjs"
  version="1.1"
  xlink="http://www.w3.org/1999/xlink"
  width="100%"
  height="100%"
  viewBox="0.000001379123659717152 0.0000018388315083939233 300.00677490234375 66.16560363769531"
  overflow="visible"
>
  <defs id="SvgjsDefs309662" />
  <g id="SvgjsG309663" transform="scale(0.6427181467084664)" opacity="1">
    <g
      id="SvgjsG309664"
      class="qGZExF_h5"
      transform="translate(40.471235928273, 7.1383887080803845) scale(1)"
      light-content="false"
      fill="#ffb000"
    >
      <path
        d="M0 0 h 58.76396886663792 v 29.361899500614406 h -58.76396886663792 Z"
      />
    </g>
    <g
      id="SvgjsG309665"
      class="76yL-jk35"
      transform="translate(7.8603807882752506, 7.1383887080803845) scale(1)"
      light-content="false"
      fill="#fe1341"
    >
      <path
        d="M0 0 h 27.139619211724703 v 88.69804312593762 h -27.139619211724703 Z"
      />
    </g>
    <g
      id="SvgjsG309666"
      class="Ll9YUHfoy"
      transform="translate(40.471235928273, 35.328312086183104) scale(1)"
      light-content="false"
      fill="#009fdf"
    >
      <path
        d="M0 0 h 58.763968866637924 v 29.36189950061442 h -58.763968866637924 Z"
      />
    </g>
    <g
      id="SvgjsG309667"
      class="u295WDqJl"
      transform="translate(40.471235928272975, 64.69021158679752) scale(1)"
      light-content="false"
      fill="#159e55"
    >
      <path
        d="M0 0 h 58.76396886663791 v 31.146220247220484 h -58.76396886663791 Z"
      />
    </g>
    <g
      id="SvgjsG309668"
      class="jiiFGNXPS"
      transform="translate(-32.599728658348276, -34.31550385089293) scale(1.7157751925446465)"
      light-content="false"
      non-strokable="false"
      fill="#ffffff"
    >
      <path
        d="M32 80h36c7.172 0 13-5.828 13-13V33c0-7.172-5.828-13-13-13H32c-7.172 0-13 5.828-13 13v34c0 7.172 5.828 13 13 13zm12-54h24c3.86 0 7 3.14 7 7v5H44zm0 18h31v12H44zm0 18h31v5c0 3.86-3.14 7-7 7H44zM25 33c0-3.86 3.14-7 7-7h6v48h-6c-3.86 0-7-3.14-7-7z"
      />
    </g>
    <g
      id="SvgjsG309669"
      class="text"
      transform="translate(293.8080636162349, 74.90597428367866) scale(1)"
      light-content="false"
      fill="currentColor"
    >
      <path
        d="M-166.69 -44.83L-166.69 0L-146.33 0C-141.46 0 -137.16 -0.93 -133.42 -2.79C-129.69 -4.64 -126.78 -7.26 -124.71 -10.63C-122.64 -14 -121.61 -17.93 -121.61 -22.41C-121.61 -26.9 -122.64 -30.82 -124.71 -34.2C-126.78 -37.57 -129.69 -40.18 -133.42 -42.04C-137.16 -43.9 -141.46 -44.83 -146.33 -44.83ZM-146.84 -8.52L-156.32 -8.52L-156.32 -36.31L-146.84 -36.31C-142.36 -36.31 -138.78 -35.06 -136.11 -32.56C-133.44 -30.07 -132.11 -26.68 -132.11 -22.41C-132.11 -18.14 -133.44 -14.76 -136.11 -12.26C-138.78 -9.77 -142.36 -8.52 -146.84 -8.52Z M-98.27 -2.24C-94.53 -0.23 -90.34 0.77 -85.68 0.77C-81.03 0.77 -76.84 -0.23 -73.13 -2.24C-69.42 -4.25 -66.49 -7.01 -64.36 -10.53C-62.22 -14.06 -61.16 -18.02 -61.16 -22.41C-61.16 -26.81 -62.22 -30.77 -64.36 -34.29C-66.49 -37.81 -69.42 -40.58 -73.13 -42.58C-76.84 -44.59 -81.03 -45.59 -85.68 -45.59C-90.34 -45.59 -94.53 -44.59 -98.27 -42.58C-102 -40.58 -104.93 -37.81 -107.04 -34.29C-109.15 -30.77 -110.21 -26.81 -110.21 -22.41C-110.21 -18.02 -109.15 -14.06 -107.04 -10.53C-104.93 -7.01 -102 -4.25 -98.27 -2.24ZM-78.51 -9.89C-80.64 -8.68 -83.04 -8.07 -85.68 -8.07C-88.33 -8.07 -90.72 -8.68 -92.85 -9.89C-94.99 -11.11 -96.66 -12.81 -97.88 -14.98C-99.1 -17.16 -99.71 -19.64 -99.71 -22.41C-99.71 -25.19 -99.1 -27.66 -97.88 -29.84C-96.66 -32.02 -94.99 -33.72 -92.85 -34.93C-90.72 -36.15 -88.33 -36.76 -85.68 -36.76C-83.04 -36.76 -80.64 -36.15 -78.51 -34.93C-76.38 -33.72 -74.7 -32.02 -73.48 -29.84C-72.27 -27.66 -71.66 -25.19 -71.66 -22.41C-71.66 -19.64 -72.27 -17.16 -73.48 -14.98C-74.7 -12.81 -76.38 -11.11 -78.51 -9.89Z M-46.94 -44.83L-46.94 0L-26.58 0C-21.71 0 -17.41 -0.93 -13.67 -2.79C-9.94 -4.64 -7.03 -7.26 -4.96 -10.63C-2.89 -14 -1.86 -17.93 -1.86 -22.41C-1.86 -26.9 -2.89 -30.82 -4.96 -34.2C-7.03 -37.57 -9.94 -40.18 -13.67 -42.04C-17.41 -43.9 -21.71 -44.83 -26.58 -44.83ZM-27.09 -8.52L-36.57 -8.52L-36.57 -36.31L-27.09 -36.31C-22.61 -36.31 -19.03 -35.06 -16.36 -32.56C-13.69 -30.07 -12.36 -26.68 -12.36 -22.41C-12.36 -18.14 -13.69 -14.76 -16.36 -12.26C-19.03 -9.77 -22.61 -8.52 -27.09 -8.52Z M12.36 -44.83L12.36 0L32.72 0C37.59 0 41.89 -0.93 45.63 -2.79C49.36 -4.64 52.27 -7.26 54.34 -10.63C56.41 -14 57.44 -17.93 57.44 -22.41C57.44 -26.9 56.41 -30.82 54.34 -34.2C52.27 -37.57 49.36 -40.18 45.63 -42.04C41.89 -43.9 37.59 -44.83 32.72 -44.83ZM32.21 -8.52L22.73 -8.52L22.73 -36.31L32.21 -36.31C36.69 -36.31 40.27 -35.06 42.94 -32.56C45.61 -30.07 46.94 -26.68 46.94 -22.41C46.94 -18.14 45.61 -14.76 42.94 -12.26C40.27 -9.77 36.69 -8.52 32.21 -8.52Z M69.03 -1.28C70.23 -0.09 71.7 0.51 73.45 0.51C75.2 0.51 76.67 -0.09 77.87 -1.28C79.06 -2.48 79.66 -3.97 79.66 -5.76C79.66 -7.6 79.06 -9.08 77.87 -10.21C76.67 -11.35 75.2 -11.91 73.45 -11.91C71.7 -11.91 70.23 -11.35 69.03 -10.21C67.84 -9.08 67.24 -7.6 67.24 -5.76C67.24 -3.97 67.84 -2.48 69.03 -1.28Z M93.56 -44.83L93.56 0L126.41 0L126.41 -8.45L103.93 -8.45L103.93 -44.83Z M155.55 -15.88L172.97 -44.83L162.78 -44.83L150.81 -24.91L138.83 -44.83L127.82 -44.83L145.17 -16.01L145.17 0L155.55 0Z"
      />
    </g>
  </g>
</svg>
